import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import {
  insCommentListPath,
  InsCommentListUrlQueryParams,
  InsCommentListUrlSortField,
  insCommentPath
} from "./urls";
import InsCommentDetailsComponent from "./views/InsCommentDetails";
import InsCommentListComponent from "./views/InsCommentList";

const InsCommentList: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: InsCommentListUrlQueryParams = asSortParams(
    qs,
    InsCommentListUrlSortField
  );
  return <InsCommentListComponent params={params} />;
};

const InsCommentDetails: React.FC<RouteComponentProps<{ id: string }>> = ({
  match
}) => <InsCommentDetailsComponent id={decodeURIComponent(match.params.id)} />;

export const InsCommentSection: React.FC = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.comment)} />
      <Switch>
        <Route exact path={insCommentListPath} component={InsCommentList} />
        <Route path={insCommentPath(":id")} component={InsCommentDetails} />
      </Switch>
    </>
  );
};

export default InsCommentSection;
